import { EaseSubscription } from './types';

export function buildOptimisticDeleteEaseState(ease: EaseSubscription) {
  return {
    ...ease,
    isPendingDowngrade: true,
  };
}
